import { t } from "i18next";

import { type EmailErrorCode, validateEmail } from "./Utils";

/**
 * Возвращает локализованное сообщение об ошибке валидации email
 */
const getEmailErrorMessage = (errorCode: EmailErrorCode): string => {
	const messages: Record<EmailErrorCode, string> = {
		email_required: t("email_validation.required", "Email is required"),
		email_too_short: t("email_validation.too_short", "Email is too short"),
		email_too_long: t("email_validation.too_long", "Email is too long"),
		email_invalid_format: t("email_validation.invalid_format", "Invalid email address"),
		email_local_part_too_long: t("email_validation.local_part_too_long", "Email local part is too long"),
		email_domain_too_long: t("email_validation.domain_too_long", "Email domain is too long"),
		email_consecutive_dots: t("email_validation.consecutive_dots", "Email cannot contain consecutive dots"),
		email_dot_boundary: t("email_validation.dot_boundary", "Email cannot start or end with a dot")
	};

	return messages[errorCode];
};

/**
 * Валидирует email и возвращает локализованное сообщение об ошибке
 */
export const validateEmailWithMessage = (value: string | null | undefined): string | null => {
	const result = validateEmail(value);
	if (result.isValid) return null;
	return result.errorCode ? getEmailErrorMessage(result.errorCode) : getEmailErrorMessage("email_invalid_format");
};
